
import styles from "./Style.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BookingInfoLoader = () => {
  return (
    <div className={styles.bookingInfoLoader}>

      {/* Top Section */}
      <div className={styles.HeaderSection}>
        <div className={`${styles.col} ${styles.leftCol}`}>
          <Skeleton width={140} height={18} />
          <Skeleton width={80} height={10} />
        </div>
        <div className={`${styles.col} ${styles.rightCol}`}>
          <Skeleton width={32} height={32} />
          <Skeleton width={32} height={32} />
        </div>
      </div>
      {/* Top Section (Check-in & Checkout button) */}
      <div className={styles.topSection}>
        <Skeleton width={130} height={18} /> {/* Checked in */}
        <Skeleton width={110} height={38} borderRadius={6} /> {/* Checkout button */}
      </div>

      {/* Date & Time */}
      <div className={styles.dateTime}>
        <div className={styles.col}>
            <Skeleton width={120} height={20} />
        </div>
        <div className={styles.col}>
            <Skeleton width={120} height={20} />
        </div>
      </div>

      {/* Client Info */}
      <div className={styles.clientInfo}>
        <div className={styles.avatar}>
          <Skeleton circle width={60} height={60} />
        </div>
        <div className={styles.clientText}>
          <Skeleton width={180} height={20} />
          <Skeleton width={120} height={10} />
          <Skeleton width={150} height={10} />
        </div>
      </div>

      {/* Service Info */}
      <div className={styles.serviceInfo}>
        <Skeleton width={200} height={20} /> {/* Service Name */}
        <div className={styles.gap}/>
        <Skeleton width={140} height={15} /> {/* With therapist */}
        <Skeleton width={140} height={15} /> {/* Duration */}
        <Skeleton width={160} height={15} /> {/* Time */}
        <Skeleton width={180} height={15} /> {/* Room */}
        <Skeleton width={150} height={15} /> {/* Requests */}
      </div>

      {/* Client Info */}
      <div className={styles.memberInfo}>
        <div className={styles.avatar}>
          <Skeleton circle width={40} height={40} />
        </div>
        <div className={styles.clientText}>
          <Skeleton width={180} height={15} />
        </div>
      </div>

      {/* Service Info */}
      <div className={styles.serviceInfo}>
        <Skeleton width={200} height={20} /> {/* Service Name */}
        <div className={styles.gap}/>
        <Skeleton width={140} height={15} /> {/* With therapist */}
        <Skeleton width={140} height={15} /> {/* Duration */}
        <Skeleton width={160} height={15} /> {/* Time */}
        <Skeleton width={180} height={15} /> {/* Room */}
        <Skeleton width={150} height={15} /> {/* Requests */}
      </div>

      {/* Booking Details */}
      <div className={styles.bookingDetails}>
        <Skeleton width={140} height={20} />
        <div className={styles.gap}/>
        <Skeleton width={200} height={15} />
        <Skeleton width={200} height={15} />
        <Skeleton width={200} height={15} />
        {/* <Skeleton width={200} height={15} /> */}
      </div>
    </div>
  );
};

export default BookingInfoLoader;
